<h1 mat-dialog-title class="dialog-title">{{ dialogData.title }}</h1>
<div mat-dialog-content class="dialog-content">
  @if (dialogData.timer) {
    <div [innerHTML]="formattedDescription"></div>
  } @else {
    <div [innerHTML]="dialogData.description"></div>
  }

  @if (dialogData.actionMessage?.message) {
    <div *accessControl="dialogData.actionMessage?.roles">
      <div [innerHTML]="dialogData.actionMessage?.message"></div>
    </div>
  }
</div>

<div mat-dialog-actions class="dialog-footer">
  @if (dialogData.secondaryButtonLabel) {
    <button appReadOnly mat-button type="button" (click)="onAction(false)">
      {{ dialogData.secondaryButtonLabel }}
    </button>
  }

  @if (dialogData.primaryButtonLabel?.label) {
    <button
      appReadOnly
      type="button"
      mat-flat-button
      color="primary"
      (click)="onAction(true)"
      [profetProgressButton]="inProgress"
      *accessControl="dialogData.primaryButtonLabel?.roles"
    >
      {{ dialogData.primaryButtonLabel?.label }}
    </button>
  }

  @if (dialogData.warnButtonLabel) {
    <button
      appReadOnly
      mat-button
      type="button"
      color="warn"
      (click)="onAction(true)"
      [profetProgressButton]="inProgress"
    >
      {{ dialogData.warnButtonLabel }}
    </button>
  }
</div>
